// React
import React from "react";

// MUI
import { Fade, Typography, Stack } from "@mui/material";

// Components
import { CardInfo, FormikTextField } from "Common/Components";

// Form Fields
import {
  clientFields,
  generalInfoFieldRows,
  generalInfoFields,
  generalInfoFrenchFields,
} from "../Common/fields";

//styles
import { textStyles } from "Common/Styles";

const GeneralInfoPage = ({
  formik,
  allClients,
  setSelectedClient,
  setAppointmentTypes,
  loadingClients,
  viewOnly = false,
}) => {
  const fieldMap = Object.fromEntries(generalInfoFields.map((f) => [f.id, f]));

  const handleChangeClient = (event, formik) => {
    formik.handleChange(event);

    const client = allClients.find(
      (client) => client.id === event.target.value
    );
    setSelectedClient(client);

    if (client) {
      setAppointmentTypes(client.appointmentReasons.map((reason) => reason.en));
    } else {
      setAppointmentTypes([]);
    }
    // Clear selected types
    formik.setFieldValue(
      "appointmentSuggestions",
      formik.values.appointmentSuggestions.map((suggestion) => ({
        ...suggestion,
        type: [],
      }))
    );
    formik.setFieldValue("location", "");
  };

  return (
    <>
      <CardInfo
        title="General Information"
        tooltipInfo="General information about the clinic"
      >
        {generalInfoFieldRows.map((row, rowIdx) => (
          <Stack direction="row" alignItems="flex-start" gap={2} key={rowIdx}>
            {row.map((fieldId) => {
              const field = fieldMap[fieldId];
              return (
                <FormikTextField
                  key={field.id}
                  formik={formik}
                  field={{
                    ...field,
                    ...(viewOnly && { disabled: true, review: true }),
                  }}
                  name={field.id}
                />
              );
            })}
          </Stack>
        ))}
      </CardInfo>

      <CardInfo
        title="French Information"
        tooltipInfo="Please provide French information for the clinic"
      >
        {generalInfoFrenchFields.map((field) => (
          <FormikTextField
            key={field.id}
            formik={formik}
            field={{
              ...field,
              ...(viewOnly && { disabled: true, review: true }),
            }}
            name={field.id}
          />
        ))}
      </CardInfo>
      <CardInfo
        title="Select Client"
        tooltipInfo="Select a client associated with this clinic"
      >
        {loadingClients ? (
          <Typography sx={textStyles.infoText}>Loading clients...</Typography>
        ) : (
          <Fade in timeout={400} unmountOnExit>
            <div>
              {clientFields.map((field) => (
                <FormikTextField
                  key={field.id}
                  formik={formik}
                  field={{
                    ...field,
                    ...(viewOnly && { disabled: true, review: true }),
                    options: allClients.map((client) => ({
                      value: client.id,
                      label: client.name,
                    })),
                  }}
                  name={field.id}
                  onChange={(event) => handleChangeClient(event, formik)}
                />
              ))}
            </div>
          </Fade>
        )}
      </CardInfo>
    </>
  );
};

export default GeneralInfoPage;
